import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.editModel ? _c('div', [_c('p', [_vm._v(_vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.headerAlarmFiltersDescription')))]), _c(VRow, [_vm.smartGroupList.length === 0 && _vm.smartGroupsFinishedLoading ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20-card', {
    staticClass: "dt-card-text-01 payload"
  }, [_c(VAlert, {
    staticClass: "mb-1",
    staticStyle: {
      "padding-left": "0px",
      "padding-top": "5px"
    },
    attrs: {
      "value": true,
      "color": "transparent",
      "icon": "fal fa-exclamation-circle"
    }
  }, [_c('span', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('AlarmLogs.reports.wizard.emptySmartgroup')) + "\n          ")])])], 1)], 1) : _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('AlarmLogs.reports.wizard.smartGroup'),
      "items": _vm.smartGroupList,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "readonly": !!_vm.editModel.id,
      "disabled": !!_vm.editModel.id,
      "loading": _vm.smartGroupList.length === 0,
      "item-text": "title",
      "item-value": "id",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n          " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n        ")];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n              " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n            ")])], 1)];
      }
    }], null, false, 1639470184),
    model: {
      value: _vm.editModel.smartGroupId,
      callback: function ($$v) {
        _vm.$set(_vm.editModel, "smartGroupId", $$v);
      },
      expression: "editModel.smartGroupId"
    }
  })], 1), _vm.editModel.filters.originType === 'virtual-device--health-state' ? _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "items": _vm.operationalStatuses,
      "return-object": false,
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": "",
      "chips": "",
      "small-chips": ""
    },
    model: {
      value: _vm.editModel.filters.operationalStatus,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.filters, "operationalStatus", $$v);
      },
      expression: "editModel.filters.operationalStatus"
    }
  })], 1) : _vm._e(), _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.category.label'),
      "items": _vm.logCategories,
      "return-object": false,
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": "",
      "chips": "",
      "small-chips": "",
      "multiple": ""
    },
    model: {
      value: _vm.editModel.filters.categories,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.filters, "categories", $$v);
      },
      expression: "editModel.filters.categories"
    }
  })], 1), _vm.editModel.filters.originType === 'virtual-device--health-state' ? _c(VCol, {
    attrs: {
      "cols": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('AlarmLogs.table.headers.severity'),
      "items": [{
        value: 'warning',
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeWarning')
      }, {
        value: 'error',
        text: _vm.$i18n_t('DigitalTwin.VirtualDevice.state.health.typeError')
      }],
      "return-object": false,
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": "",
      "chips": "",
      "small-chips": "",
      "multiple": ""
    },
    model: {
      value: _vm.editModel.filters.severities,
      callback: function ($$v) {
        _vm.$set(_vm.editModel.filters, "severities", $$v);
      },
      expression: "editModel.filters.severities"
    }
  })], 1) : _vm._e()], 1), _c(VRow, [_c(VCol, {
    directives: [{
      name: "col",
      rawName: "v-col"
    }],
    attrs: {
      "cols": "4",
      "sm": "4"
    }
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.editModel.smartGroupId,
      "appendIcon": "fa-arrow-right"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('nextStep');
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.continueBtn')) + "\n      ")])], 1)], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };